var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGuideLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0751 10.7234C9.31973 11.7121 8.31818 13.7609 8 14.3337L8 5.33366C8.27631 4.8363 9.06798 3.4113 10.4211 2.44278C10.9912 2.03477 11.2762 1.83076 11.6381 2.01678C12 2.2028 12 2.61341 12 3.43463L12 9.32792C12 9.77155 12 9.99336 11.9089 10.1492C11.8178 10.3051 11.5702 10.4445 11.0751 10.7234Z",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 5.2037C7.54224 4.72269 6.21467 3.58027 3.9872 3.17972C2.85876 2.9768 2.29454 2.87534 1.81402 3.26422C1.3335 3.6531 1.3335 4.28458 1.3335 5.54756L1.3335 10.0865C1.3335 11.2413 1.3335 11.8187 1.64189 12.1792C1.95029 12.5397 2.62926 12.6618 3.9872 12.9059C5.19772 13.1236 6.14246 13.4704 6.82628 13.819C7.49908 14.1619 7.8355 14.3333 8.00016 14.3333C8.16483 14.3333 8.50124 14.1619 9.17404 13.819C9.85787 13.4704 10.8026 13.1236 12.0131 12.9059C13.3711 12.6618 14.05 12.5397 14.3584 12.1792C14.6668 11.8187 14.6668 11.2413 14.6668 10.0865L14.6668 5.54756C14.6668 4.28458 14.6668 3.6531 14.1863 3.26422C13.7058 2.87534 12.6668 3.17972 12.0002 3.66667",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGuideLines);
export default __webpack_public_path__ + "static/media/icon-guide-lines.b01cd8f2a0aef19a1771950bc1a1d667.svg";
export { ForwardRef as ReactComponent };